var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Profile",
    width: 24,
    height: 24,
    "data-name": "Icon - Profile",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:#fff;opacity:0}.prefix__cls-2{fill:#0baf50}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0h24v24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Profile-2",
    "data-name": "Icon - Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0h16v16H0z",
    className: "prefix__cls-1",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Profile-3",
    "data-name": "Icon - Profile",
    transform: "translate(3.998 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6178",
    d: "M3.139 16c-1.521 0-2.568-1.98-1.963-3.75C2.319 8.9 4.945 6.564 8 6.564s5.683 2.34 6.826 5.686c.6 1.77-.442 3.75-1.963 3.75z",
    className: "prefix__cls-2",
    "data-name": "Path 6178"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_748",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 748",
    transform: "translate(3.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3512",
    "data-name": "Group 3512",
    transform: "translate(-11.845 2.561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_1714",
    width: 8,
    height: 2,
    fill: "#fed148",
    "data-name": "Rectangle 1714",
    rx: 1,
    transform: "translate(15.847 9.439)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.451096fc5a78390cc677b158b909d694.svg";
export { ForwardRef as ReactComponent };